export default {
  // 推荐页
  // 产品tab名
  smw_bspl_group_title: '产品',
  // 产品页操作：开车
  smw_bspl_group: '开车',
  // 作品tab名：作品
  smw_bspl_product_title: '作品',
  // 作品页操作：上新
  smw_bspl_product: '上新',

  // 详情页(smallProduct和newSmallProduct)
  // 购买按键
  smw_smproduct_buy: '我要跟车',
  // 说明
  smw_smproduct_rule: '跟车说明',
  // 购买价
  smw_smproduct_price: '跟车价',
  // 购买人数
  smw_smproduct_buynum: '人已跟车',
  // 开团人数
  smw_smproduct_groupnum: '人已跟车',

  // 分享页
  // 发车说明同 smw_smproduct_rule
  // 购买人头像
  smw_smproduct_buyer: '已跟车',

  // 撒米屋
  // 购买数量
  smw_association_buynum: '跟车人数',
  // 邀请
  smw_association_invit: '邀请上车',
  // 购买按钮
  smw_association_buy: '跟车',

  // 在线拼贴 上新 同 smw_bspl_product
  // 非本人页面关注按钮
  smw_association_following: '加入',

  // 我的
  // 开车管理
  smw_my_groupmanage: '开车管理',
  // 大团管理icon及内页标题
  smw_my_groupmanage_product: '我的发车',
  // 大小管理内页 小团链接
  smw_my_groupmanage_product_group: '跟车',
  // 小团管理icon及内页标题
  smw_my_groupmanage_group: '我的跟车',
  // 上新icon及内页标题
  smw_my_groupmanage_new: '我要开车',
  // 上新内页提交按钮
  smw_my_groupmanage_new_sumbmit: '上新',
  // 作品管理
  smw_my_picmanage: '作品管理',
  // 上传作品及内页标题，内页上传项
  smw_my_picmanage_upload: '上传作品',
  // 创意库及内页标题
  smw_my_picmanage_lib: '我的画稿箱',
  // 创意库上新按钮
  smw_my_picmanage_lib_newproduct: '上新产品',
  // 作品收益icon及内页标题
  smw_my_picmanage_lib_profit: '作品收益',
  // 作品收益内页发车次数
  smw_my_picmanage_lib_profit_products: '发车次数',

  // 我的收益（由撒米进入）
  // 小团收益
  smw_my_myprofit_group: '跟车收益',
  // 大团收益
  smw_my_myprofit_product: '发车收益',
  // IP收益
  smw_my_myprofit_ip: 'IP收益'
}



// WEBPACK FOOTER //
// ./src/utils/smwdict.js